import { combineReducers } from 'redux';
import axios from 'axios';
import humps from 'humps';
import qs from 'qs';
import saveAs from 'file-saver';
import _ from 'lodash';

import * as Urls from 'src/constants/EndpointUrls';
import { excludeValuesIfNotDefined } from 'src/utils/Http';
import createNamedWrapperReducer from 'src/reducers/createNamedWrapperReducer';
import { listReducer, itemReducer } from 'src/reducers/common';
import { newItemFailure, setItemError } from 'src/reducers/common/itemReducer';
import { fetchList, fetchListSuccess, fetchListFailure } from 'src/reducers/common/listReducer';

export const REDUCER_NAME = 'reportHealthInsuranceBonus';
export const clearErrors = () => dispatch => dispatch(newItemFailure(REDUCER_NAME, []));
export const setErrors = errors => dispatch => dispatch(newItemFailure(REDUCER_NAME, errors));

// Async Action Creators
export const fetchReportHealthInsuranceBonus = queries => async dispatch => {
  try {
    dispatch(fetchList(REDUCER_NAME));
    const excluedQueries = excludeValuesIfNotDefined(queries);
    const response = await axios.get(Urls.REPORT_HEALTH_INSURANCE_BONUS_SEARCH, {
      params: humps.decamelizeKeys(excluedQueries)
    });
    const { totalCount = 0, displayFrom = 0, displayTo = 0 } = response.data.payload;
    const payload = {
      data: response.data.payload.employeeBonus,
      pageCount: response.data.payload.totalPages,
      totalCount,
      displayFrom,
      displayTo
    };
    dispatch(fetchListSuccess(REDUCER_NAME, payload));
  } catch (exception) {
    dispatch(fetchListFailure(REDUCER_NAME, exception.response.data.errors.messages));
  }
};

export const downloadCsv = (data, bonusId, callBack) => async dispatch => {
  try {
    const params = {
      payment_for: data.paymentFor,
      serial_number: data.serialNumber,
      business_owner_last_name: data.businessOwnerLastName,
      business_owner_first_name: data.businessOwnerFirstName,
      bonusId
    };
    const query = qs.stringify(humps.decamelizeKeys({ csv: params }), { arrayFormat: 'brackets' });
    const downloadUrl = `${Urls.REPORT_HEALTH_INSURANCE_BONUS_CSV}?${query}`;
    const response = await fetch(downloadUrl);

    if (_.includes(response.headers.get('Content-Type'), 'application/json')) {
      const json = await response.json();
      throw new Error(json.errors.messages);
    } else {
      const responseBlob = await response.blob();
      const blob = new Blob([responseBlob], { type: 'text/csv' });
      const fileName = decodeURI(response.headers.get('content-disposition').match(/filename="(.*)"/)[1]);
      saveAs(blob, fileName);
    }
  } catch (exception) {
    dispatch(setItemError(REDUCER_NAME, exception.message.split(',')));
  } finally {
    callBack();
  }
};

export default combineReducers({
  list: createNamedWrapperReducer(listReducer, REDUCER_NAME),
  item: createNamedWrapperReducer(itemReducer, REDUCER_NAME)
});
